import React, { Component } from "react";
import SuccessStoriesButton from "../../components/buttons/SuccessStoriesButton";

class SuccessStory extends Component{

	constructor(props){
		super(props);
		this.state={

		}
	}

	render() {
		return (
			<section className="success-story">
				  <div className="success-img" style={{backgroundImage:`url(images/testimonial-slide-5.jpg)`}}>
				  <div className="top-shape"></div>
    <div className="bottom-shape"></div>

  <div className="rounded-top-right-corner"></div>

  <div className="rounded-bottom-left-corner"></div>

  <div className="rounded-bottom-right-corner"></div>
				  </div>
				  <div className="success-content animate-fade">
				    <h2>“In my first full month of Webtalk Rewards I made over $9,000! Simply Amazing.”</h2>
				    <p>Alfonso Torres, Real Estate Agent at EXP Realty</p>
				    <SuccessStoriesButton/>
				  </div>
			</section>
		);
	}

};

export default SuccessStory;